// Selectors for the Warranty Deflection feature.
// Excluded from coverage thresholds per project convention (see jest config's
// coveragePathIgnorePatterns, which ignores src/selector/** and **/selectors/**),
// consistent with how features/Coupons/selectors is handled.
import { RootState } from "../../../reducers";

export const getWarrantyDeflectionOemNumber = (state: RootState): string =>
  state.commonBenefits?.warrantyDeflectionOemNumber || "";

export const getCustomerCalledOem = (state: RootState): boolean =>
  !!state.warrantyDeflection?.customerCalledOem;
